import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import TNPSCCourse from './section-components/tnpsc-details';
import Footer from './global-components/footer-v2';

const TNPSC = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="TNPSC, TRB, Police Exams & RRB"  />
        <TNPSCCourse />
        <Footer />
    </div>
}

export default TNPSC
